import React from 'react';
import Confetti from 'react-confetti';

import StandardModal from '@/components/commons/StandardModal';
import CloseButton from '@/components/commons/icons/CloseButton';

import CardHeader from './CardHeader';
import CardBody from './CardBody';
import { cgEndCard } from './data';
import Timer from './Timer';
import EndCard from './EndCard';
import ModalButtons from './ModalButtons';
import ClosingModal from './ClosingModal';
import NoQuestions from './NoQuestions';
import ReviewAnswers from './ReviewAnswers';

function CardModal({
    isModalOpen,
    data,
    startGame,
    showNoQuestions,
    showClosingModal,
    showWarningModal,
    closeModal,
    skipQuestion,
    actualQuestion,
    saveQuestionData,
    noMoreQuestions,
    toggleEndGame,
    prevQuestion,
    time,
    pauseTimer,
    isPaused,
    requestError,
    multipleErrorOnSending,
    toggleShowReviewAnswers,
    showReviewAnswers,
    answers,
    currentlySending,
}) {
    const modalClassNames = {
        modal: 'w-full h-full bg-transparent shadow-none rounded-lg p-0 m-0',
        closeButton: 'hidden',
    };

    let showData;
    let endGame = false;

    if (time === 0 || noMoreQuestions) {
        endGame = true;
    }

    if (!endGame) {
        showData = data[actualQuestion];
    } else {
        showData = cgEndCard;
    }

    return (
        <div className="relative flex items-center justify-center">
            {endGame && (
                <Confetti
                    className="z-[10000] w-full fixed"
                    gravity={0.2}
                    numberOfPieces={1000}
                    tweenDuration={3000}
                    recycle={false}
                />
            )}
            {(!endGame) && (
                <>
                    <div className="fixed top-4 left-4 z-[10000] text-cirrusWhite cursor-pointer">
                        <ModalButtons
                            prevQuestion={actualQuestion === 0 ? null : prevQuestion}
                            pauseTimer={pauseTimer}
                            isPaused={isPaused}
                        />
                    </div>
                    <div className="fixed top-4 right-4 z-[10000] text-cirrusWhite cursor-pointer">
                        <div className="fixed flex top-4 right-4 z-[10000] text-cirrusWhite cursor-pointer">
                            <button
                                type="button"
                                data-tooltip-id="tip"
                                title="Close Game"
                                aria-label="Close Game"
                                onClick={() => closeModal()}
                                className="w-full rounded-lg bg-transparent flex items-center justify-center py-2 px-4 my-3 pt-[6px] mr-0 "
                            >
                                <CloseButton className="w-7 h-7 " />
                            </button>
                        </div>
                    </div>
                </>
            )}
            <StandardModal
                open={isModalOpen}
                onClose={(endGame) ? closeModal : showClosingModal}
                headline={null}
                classNames={modalClassNames}
                styles={null}
            >
                {!requestError ? (
                    <div className="relative flex flex-col items-center justify-center w-full bg-transparent rounded-xl">
                        {!endGame ? (
                            <Timer
                                time={time}
                                isPaused={endGame ? false : isPaused}
                            />
                        ) : (
                            <div className="h-6" />
                        )}
                        {(showNoQuestions && (
                            <NoQuestions closeModal={closeModal} />
                        )) || (showReviewAnswers && (
                            <ReviewAnswers
                                closeModal={closeModal}
                                answers={answers}
                                saveQuestionData={saveQuestionData}
                                currentlySending={currentlySending}
                            />
                        )) || (
                            <>
                                {!endGame
                                    ? (
                                        <CardHeader
                                            data={data[actualQuestion]}
                                            startCard={false}
                                        />
                                    )
                                    : <EndCard />}
                                <CardBody
                                    data={showData}
                                    gameStarted
                                    startGame={startGame}
                                    skipQuestion={skipQuestion}
                                    saveQuestionData={saveQuestionData}
                                    noMoreQuestions={endGame}
                                    toggleEndGame={toggleEndGame}
                                    toggleShowReviewAnswers={toggleShowReviewAnswers}
                                />
                            </>
                        )}
                    </div>
                ) : (
                    <ClosingModal
                        isModalOpen={isModalOpen}
                        showClosingModal={showClosingModal}
                        showWarningModal
                        closeModal={closeModal}
                        modalType={1}
                    />
                )}
            </StandardModal>
            {(showWarningModal && !endGame) && (
                <ClosingModal
                    isModalOpen={isModalOpen}
                    showClosingModal={showClosingModal}
                    showWarningModal={showWarningModal}
                    closeModal={closeModal}
                    modalType={0}
                />
            )}
            {multipleErrorOnSending && (
                <ClosingModal
                    isModalOpen={isModalOpen}
                    showClosingModal={showClosingModal}
                    showWarningModal
                    closeModal={closeModal}
                    modalType={2}
                />
            )}
        </div>
    );
}

export default CardModal;
